import { render } from "./CreateClaimView.vue?vue&type=template&id=3b5de450"
import script from "./CreateClaimView.vue?vue&type=script&lang=js"
export * from "./CreateClaimView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__